var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#file-download-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.667 5.846V.396c.76.287 1.46.732 2.054 1.324l2.904 2.905a5.8 5.8 0 0 1 1.325 2.053H12.5a.833.833 0 0 1-.833-.832m6.647 2.5H12.5a2.503 2.503 0 0 1-2.5-2.5V.032c-.134-.01-.268-.02-.404-.02H5.834a4.173 4.173 0 0 0-4.167 4.167v11.667a4.17 4.17 0 0 0 4.167 4.167h8.333a4.17 4.17 0 0 0 4.167-4.167V8.75c0-.136-.011-.27-.02-.404m-5.225 7.088-1.344 1.345a2.46 2.46 0 0 1-1.745.722c-.631 0-1.264-.24-1.745-.722l-1.344-1.345a.832.832 0 1 1 1.178-1.178l1.078 1.077v-3.665a.833.833 0 1 1 1.667 0v3.665l1.077-1.077a.832.832 0 1 1 1.178 1.178"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "file-download-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export { SvgFileDownloadIcon as ReactComponent };
export default __webpack_public_path__ + "c5784e944254e33768665c9acd33387e.svg";